import {Component, Input, OnInit} from '@angular/core';
import {BaseModal} from '@ui-app/modals/base-modal';
import {EmployeeDataAccessService} from '../../core/services/data-access.service';
import * as EmployeeModels from '@employee-models/index';
import {CommonConfig} from '@employee-configs/common.config';

@Component({
    selector: 'employee-mobile-badge-request-fullscreen-modal',
    templateUrl: './mobile-badge-request-full-screen-modal.component.html',
    styleUrls: ['./mobile-badge-request-full-screen-modal.component.less']
})
export class MobileBadgeRequestFullScreenModalComponent extends BaseModal implements OnInit {

    @Input() currentUserId: number;

    readonly ICONS = {
        [EmployeeModels.DE.MobileRequestReasonEnum.InitialBadge]:
            `${CommonConfig.employeeRequestReasonImgAssets}/no-photo.svg`,
        [EmployeeModels.DE.MobileRequestReasonEnum.LostPhone]:
            `${CommonConfig.employeeMobileBadgeRequestReasonImgAssets}/lost-phone.svg`,
        [EmployeeModels.DE.MobileRequestReasonEnum.WeeklyTraveler]:
            `${CommonConfig.employeeMobileBadgeRequestReasonImgAssets}/weekly-traveler.svg`
    };

    get isSubmitEnabled(): boolean {
        return !!this.selectedReasonId && this.isConfirmed;
    }

    reasons: EmployeeModels.CM.IReason[] = [];
    isConfirmed: boolean = false;
    selectedReasonId: EmployeeModels.DE.MobileRequestReasonEnum = null;
    isMobileBadgingEnabledOnSite: boolean = false;

    constructor(private dataAccessService: EmployeeDataAccessService) { super(); }

    ngOnInit(): void {
        this.subs = this.dataAccessService.badgeRequestsService.getMobileBadgeRequestInfo(this.currentUserId)
            .subscribe((data: EmployeeModels.DM.IMobileBadgeRequestInfo) => {
                const reasons: EmployeeModels.DM.IMobileBadgeRequestReasonModel[] = [...data.modibleBadgeRequestReasons];
                if (reasons.length) {
                    this.reasons = reasons.map((reason: EmployeeModels.DM.IMobileBadgeRequestReasonModel) => ({
                        ...reason, icon: this.ICONS[reason.mobileRequestReasonId]
                    }));
                }
                this.isMobileBadgingEnabledOnSite = data.isMobileBadgingEnabledOnSite;
            });
    }

    selectReasonId(mobileRequestReasonId: EmployeeModels.DE.MobileRequestReasonEnum): void {
        this.selectedReasonId = mobileRequestReasonId;
    }

    close(): void {
        this.action(null);
    }

    submit(): void {
        this.action(this.selectedReasonId);
    }

}
